import { IonIcon } from '@ionic/react'
import { ParseKeys } from 'i18next'
import { checkmarkOutline } from 'ionicons/icons'
import { useForm, useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Button } from '~/shared/ui/Buttons'
import { Checkbox, FormProvider } from '~/shared/ui/form'
import { Modal, useModal } from '~/shared/ui/Modal'
import { myPalette } from '~/shared/ui/theme'
import { CheckBoxListWrapper, Description, Title } from './styled'

type Options = {
  options: { id: string; label: string }[]
  optionsI18n?: never
}

type OptionsI18n = {
  optionsI18n: {
    id: string
    label: ParseKeys
  }[]
  options?: never
}

type OptionsRequired = Options | OptionsI18n

type ModalButtonCheckboxesPros = {
  title: string
  buttonTitle: string
  description: string
  name: string
} & OptionsRequired

export function ModalButtonCheckboxes({
  title,
  buttonTitle,
  description,
  name,
  options,
  optionsI18n,
}: ModalButtonCheckboxesPros) {
  const { t } = useTranslation()
  const { setValue, getValues, watch } = useFormContext()
  const getDefaultValuesForm = () => getValues(name) || {}

  const form = useForm({ defaultValues: getDefaultValuesForm() })
  const { isModalShow, openModal, closeModal } = useModal()

  const values = watch(name) || {}
  const isSelectedValue = Object.entries(values).some(([, value]) => value)

  const handleOk = () => {
    const formValues = Object.fromEntries(
      Object.entries(form.getValues()).filter(
        ([, value]) => value !== undefined,
      ),
    )

    closeModal()
    setValue(name, formValues)
  }

  const handleCancel = () => {
    closeModal()
    form.reset(getDefaultValuesForm())
  }

  return (
    <>
      <Button
        onClick={openModal}
        variant='whiteBorder'
        uppercase
        endDecorator={
          isSelectedValue && (
            <IonIcon
              icon={checkmarkOutline}
              style={{
                color: myPalette.green.main,
                fontSize: '16px',
                '--ionicon-stroke-width': '60px',
              }}
            />
          )
        }
      >
        {buttonTitle}
      </Button>
      <Modal
        isShow={isModalShow}
        onCancel={handleCancel}
        onOk={handleOk}
        ok={t('button.add')}
      >
        <Title>{title}</Title>
        <Description>{description}</Description>

        <FormProvider form={form}>
          <CheckBoxListWrapper>
            {(options || []).map((option) => (
              <Checkbox key={option.id} name={option.id} label={option.label} />
            ))}
            {(optionsI18n || []).map((option) => (
              <Checkbox
                key={option.id}
                name={option.id}
                labelI18n={option.label}
              />
            ))}
          </CheckBoxListWrapper>
        </FormProvider>
      </Modal>
    </>
  )
}
